import { defineStore } from "pinia";
import type { DeploymentInfo } from "~/model/api/pLCnextStoreFrontendAPI.schemas";
import { getDeploymentInfo } from "~/model/api/pLCnextStoreFrontendAPI";
import { withErrorHandling } from "~/helpers/withErrorHandling";
import { withErrorMessage } from "~/helpers/withErrorMessage";
import { withLoading } from "~/helpers/withLoading";

interface State {
  deploymentInfo: DeploymentInfo | null;
}

export const useDeployementInfoStore = defineStore("deploymentInfo", {
  // convert to a function
  state: (): State => ({
    deploymentInfo: null, // initial state
  }),
  getters: {},
  actions: {
    async loadDeploymentInfo() {
      const { data, error } = await withErrorHandling(
        withErrorMessage(withLoading(getDeploymentInfo())),
      );
      console.debug("loadDeploymentInfo: ", data, error);
      if (data) {
        this.deploymentInfo = data;
      }
    },

    // easily reset state using `$reset`
    clear() {
      this.$reset();
    },
  },
});
